import { createContext } from "react";
import { theme, type HuddlTheme } from "@/theme";

export const ThemeContext = createContext<HuddlTheme>(theme);
